module.exports = __webpack_public_path__ + "media/images/olympic_rm_logo-c4819908366e17ba1e3b1422d02b5576.png";